import { render, staticRenderFns } from "./CourseHistoryBox.vue?vue&type=template&id=25b615ff&scoped=true&"
import script from "./CourseHistoryBox.vue?vue&type=script&lang=ts&"
export * from "./CourseHistoryBox.vue?vue&type=script&lang=ts&"
import style0 from "./CourseHistoryBox.vue?vue&type=style&index=0&id=25b615ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b615ff",
  null
  
)

export default component.exports